import {Injectable} from '@angular/core';

declare global {
    interface Window {
        google: any;
    }
}

@Injectable({
    providedIn: 'root'
})
export class GoogleMapLoaderService {
    URL = 'https://maps.googleapis.com/maps/api/js';
    KEY = null;
    CLIENT = null;
    SENSOR = false;
    VERSION = '3.59';
    LIBRARIES = 'places,drawing,visualization,geometry,marker';
    WINDOW_CALLBACK_NAME = '__google_maps_api_provider_initializator__';
    script = null;
    google = null;
    loading = false;
    callbacks = [];
    onLoadEvents = [];
    countLoadLibrary = 0;
    waitForLoadingDoneInterval;

    constructor() {}

    public load(cb, cbFail) {
      try {
        // console.log(`*********** google map loader, countLoadLibrary = ${this.countLoadLibrary}`
        // + `, this.google = ${this.google}`);
        if (this.countLoadLibrary > 0) {
          if (this.google) {
            // console.log(`***** return google without loading library`);
            cb(this.google);
          } else {
            this.callbacks.push({cb, cbFail});
            if (!this.waitForLoadingDoneInterval) {
              this.waitForLoadingDoneInterval = setInterval(() => {
                if (this.google) {
                  // console.log(`***** DONE WAITING LOADING GOOGLE LIBRARY`);
                  clearInterval(this.waitForLoadingDoneInterval);
                  this.waitForLoadingDoneInterval = null;
                  // resolve(this.google);
                  for (let i = 0; i < this.callbacks.length; i++) {
                    const obj = this.callbacks[i];
                    // console.log(`***** DONE LOAD GG , i = ${i}`);
                    obj.cb(this.google);
                  }
                  this.callbacks = []; // reset
                } else {
                  // console.log(`***** waiting for google library done loading...`);
                }
              }, 200);
            } else {
              // console.log(`***** this.waitForLoadingDoneInterval NOT NULL: ${this.waitForLoadingDoneInterval}
              // , this.callbacks.len = ${this.callbacks.length}`);
            }
          }
          
        } else {
          this.countLoadLibrary++;

          let url = this.URL;
          if (this.SENSOR === true) {
            url += '?sensor=true';
          } else {
            url += '?sensor=false';
          }
          if (this.KEY != null) {
            url += '&key=' + this.KEY;
          }
          if (this.CLIENT != null) {
            url += '&client=' + this.CLIENT;
          }
          if (this.VERSION != null) {
            url += '&v=' + this.VERSION;
          }
          if (this.LIBRARIES != null) {
            url += '&libraries=' + this.LIBRARIES;
          }
          url += '&callback=' + this.WINDOW_CALLBACK_NAME;
          url += '&loading=async';
          this.google = window.google;
          if (this.google == null) {
            this.script = document.createElement('script');
            this.script.type = 'text/javascript';
            this.script.src = url;
  
            document.body.appendChild(this.script);
  
            (window)[this.WINDOW_CALLBACK_NAME] = () => {
                this.google = window.google;
                
                cb(this.google);
            };
            this.script.onerror = (error: Event) => { cbFail(error); };
          } else {
            cb(this.google);
          }
        }
      } catch(err) {
        console.log(`**** load google library error = `, err);
        cbFail(err);
      }
    }

    async loadLibrary(library: 'maps' | 'marker' | 'geometry' | 'places'): Promise<any> {
      return this.google.importLibrary(library);
    }
}
